import { render, staticRenderFns } from "./ForgotPasswordIndex.vue?vue&type=template&id=6d913fdc&scoped=true&"
import script from "./ForgotPasswordIndex.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordIndex.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordIndex.vue?vue&type=style&index=0&id=6d913fdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d913fdc",
  null
  
)

export default component.exports